export default `
Betreiber der App
Native Studios UG (haftungsbeschränkt)
Greifswalder Straße 29
10405 Berlin

Telefon +49 30 765 832 72
Fax +49 30 240 881 81
E-Mail info@native-studios.com

Geschäftsführung
Alex Schwaderer, Johannes Kahnt

Registergericht
Amtsgericht Charlottenburg

Registernummer
HRB 175820 B
`;
